import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "page-width-inner !box-border w-full" }
const _hoisted_2 = ["action"]
const _hoisted_3 = ["placeholder", "aria-label"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "fallback-text" }
const _hoisted_6 = {
  key: 0,
  class: "page-width-inner !box-border w-full",
  style: {"padding-bottom":"var(--header-height)","margin-bottom":"calc(-1 * var(--header-height))"}
}
const _hoisted_7 = { class: "tablet:text-18" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 2 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_icon = _resolveComponent("v-icon")
  const _component_v_skeleton = _resolveComponent("v-skeleton")
  const _component_v_grid = _resolveComponent("v-grid")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", {
        action: $data.search_url,
        method: "get",
        class: "flex items-center border-b border-black-400",
        role: "search",
        autocomplete: "off"
      }, [
        _cache[4] || (_cache[4] = _createElementVNode("input", {
          type: "hidden",
          name: "type",
          value: "product"
        }, null, -1)),
        ($data.searchTerm.length > 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              onClick: _cache[0] || (_cache[0] = (...args) => ($options.resetSearch && $options.resetSearch(...args)))
            }, [
              _createVNode(_component_v_icon, {
                icon: "refresh",
                height: 12.8,
                width: 16,
                class: "mr-2"
              })
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.searchTerm) = $event)),
          name: "q",
          type: "search",
          placeholder: $data.locale.input_placeholder,
          "aria-label": $data.locale.input_placeholder,
          class: "search-input grow text-14 placeholder:text-black-400",
          onInput: _cache[2] || (_cache[2] = $event => (_ctx.debouncedSearchChange($data.searchTerm)))
        }, null, 40, _hoisted_3), [
          [_vModelText, $data.searchTerm]
        ]),
        _createElementVNode("span", null, [
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-xsmall text-black-900 hover:text-black-600",
            disabled: $data.searchTerm.length < 1
          }, [
            _cache[3] || (_cache[3] = _createElementVNode("span", { "aria-hidden": "true" }, null, -1)),
            _createElementVNode("span", _hoisted_5, _toDisplayString($data.locale.search_button), 1)
          ], 8, _hoisted_4)
        ])
      ], 8, _hoisted_2)
    ]),
    ($data.searchTerm.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (!$data.loading && $data.products.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString($data.products.length) + " " + _toDisplayString($data.locale.results), 1))
              : ($data.loading)
                ? (_openBlock(), _createBlock(_component_v_skeleton, {
                    key: 1,
                    class: "rounded-light h-5 w-1/4 tablet:h-6 tablet:w-1/12"
                  }))
                : ($data.noResults)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString($data.locale.no_results), 1))
                  : _createCommentVNode("", true)
          ]),
          (_openBlock(), _createBlock(_component_v_grid, {
            key: $data.products,
            products: $data.products,
            "loading-state": $data.loading
          }, null, 8, ["products", "loading-state"]))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}